module.exports = __webpack_public_path__ + "img/产业园信息管理平台.19a37ad0.png";